import "./List.scss";

import { FC, CSSProperties, HTMLProps } from "react";

import { ClassName } from "config/types";

import classNames from "classnames";
import { defaultTo } from "lodash-es";

export const elementTypes = {
  ul: "ul",
  ol: "ol",
  nav: "nav",
};

export type ElementType = keyof typeof elementTypes;

type IProps = HTMLProps<HTMLElement> & {
  tag?: ElementType;
  className?: ClassName;
  style?: CSSProperties;
};

const List: FC<IProps> = props => {
  const { children, tag, className, style, ...nativeProps } = props;

  const defaultTag = defaultTo(tag, "ul");

  const Tag = elementTypes[defaultTag] as "ul" | "ol" | "nav";

  const classes = classNames("list", className);

  return (
    <Tag style={style} className={classes} {...(nativeProps as React.HTMLAttributes<HTMLElement>)}>
      {children}
    </Tag>
  );
};

export default List;
